import {useCallback} from 'react';
import {useTranslation} from 'react-i18next';

import {CreditCardIcon, Icon, PaymentSourceExpiry, Tooltip} from 'components';
import {PaymentSourceStatus} from 'enums';
import {TRANSLATION_KEYS} from 'locale';
import {BillingPlatformPaymentSource} from 'types';
import {transformUtils} from 'utils/transform';

const T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.BILLING.PAYMENT_SOURCE;

type Props = {
    isPrimary: boolean;
    paymentSource: BillingPlatformPaymentSource;
    removePaymentSource: (paymentId: string) => void;
    makePrimaryPaymentSource: (paymentId: string) => void;
}

export const PaymentSource: React.FC<Props> = ({isPrimary, paymentSource, removePaymentSource, makePrimaryPaymentSource}) => {
    const {t} = useTranslation();

    const getDisabledMakePrimary = useCallback((status: PaymentSourceStatus) => status === PaymentSourceStatus.Expired, []);

    return (
        <div className='tw-mt-4 tw-flex tw-items-center'>
            <div className='tw-w-8'>
                {isPrimary ?
                    <Tooltip header={t(T_KEYS.CARD.PRIMARY)}>
                        <Icon name='star' color='warning' />
                    </Tooltip> :
                    <Tooltip disabled={getDisabledMakePrimary(paymentSource.status)} header={t(T_KEYS.CARD.MAKE_PRIMARY)}>
                        <Icon
                            button
                            group
                            name='star'
                            color='default-dimmed'
                            disabled={getDisabledMakePrimary(paymentSource.status)}
                            onClick={() => makePrimaryPaymentSource(paymentSource.id)}
                        />
                    </Tooltip>}
            </div>
            <div className='tw-flex tw-items-center tw-flex-grow'>
                <CreditCardIcon iconSize='4xl' name={paymentSource.card.brand} />
                <div className='tw-flex sm:tw-items-center tw-ml-2 -sm:tw-flex-col tw-flex-grow'>
                    <div className='sm:tw-flex-grow'>{transformUtils.formatCreditCardLabel(paymentSource.card, t)}</div>
                    <PaymentSourceExpiry paymentSource={paymentSource} />
                </div>
            </div>
            <div className='tw-flex tw-items-center -sm:tw-ml-auto'>
                <Icon
                    button
                    className='tw-ml-2'
                    name='delete'
                    color='alert'
                    onClick={() => removePaymentSource(paymentSource.id)}
                />
            </div>
        </div>
    );
};